import * as React from 'react';
import { useInView } from 'react-intersection-observer';
import { FormattedMessage } from 'react-intl';

import { ContentWrapper } from '@components';
import productDetailMessages from '@containers/ProductDetailContainer/messages';
import { IImageProperties } from '@helpers/utils';

import { MainImage } from './MainImage';
import { messages } from './messages';
import {
  Annotation,
  BuyLink,
  Description,
  DescriptionWrapper,
  H1,
  TopSection,
  WhiteBlock,
} from './styled';

interface IHeaderProps {
  annotation: string;
  brandInfoName: string;
  redirectUrl: string;
  simpleDescription: string;
  newPdDesignEnabled: boolean;
  imageAttrs: IImageProperties;
}

export const Header: React.FC<IHeaderProps> = ({
  annotation,
  brandInfoName,
  imageAttrs,
  redirectUrl,
  simpleDescription,
  newPdDesignEnabled,
}) => {
  const [ref, inView] = useInView({ initialInView: true });

  return (
    <TopSection ref={ref}>
      <MainImage imageAttrs={imageAttrs} />

      <DescriptionWrapper>
        <H1>
          <FormattedMessage
            {...productDetailMessages.reviewHeader}
            values={{ name: '' }}
          />{' '}
          {brandInfoName}
        </H1>

        <Annotation>{annotation}</Annotation>

        {simpleDescription && (
          <Description
            dangerouslySetInnerHTML={{ __html: simpleDescription }}
          />
        )}

        <BuyLink href={redirectUrl}>
          <FormattedMessage {...messages.reviewsPageBuy} />
        </BuyLink>
      </DescriptionWrapper>

      {simpleDescription && (
        <Description dangerouslySetInnerHTML={{ __html: simpleDescription }} />
      )}

      <BuyLink fullWidth={true} href={redirectUrl}>
        <FormattedMessage {...messages.reviewsPageBuy} />
      </BuyLink>

      <WhiteBlock isInView={inView}>
        <ContentWrapper newPdDesignEnabled={newPdDesignEnabled}>
          <H1>{brandInfoName}</H1>

          <BuyLink href={redirectUrl} fullWidth={true}>
            <FormattedMessage {...messages.reviewsPageBuy} />
          </BuyLink>
        </ContentWrapper>
      </WhiteBlock>
    </TopSection>
  );
};
